var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Box } from '@mui/material';
import { BackrsIcon } from './BackrsIcon';
import { appColors } from '../assets/appColors';
var getChipStyle = function (variant) {
    switch (variant.type) {
        case 'LARGE_TEXT':
            return largeChipStyle;
        case 'TINY_TEXT':
            return tinyChipStyle;
        case 'SMALL_TEXT':
        default:
            return smallChipStyle;
    }
};
export var BackrsChip = function (_a) {
    var label = _a.label, variant = _a.variant, onClick = _a.onClick, _b = _a.isSelected, isSelected = _b === void 0 ? true : _b, sx = _a.sx;
    var backgroundColors = {
        LARGE_TEXT_BLUE: appColors.color.blue1,
        LARGE_TEXT_GRAY: appColors.neutral.lightGray,
        LARGE_TEXT_LIGHT_BLUE: appColors.color.blue3,
        SMALL_TEXT: appColors.color.blue4,
        TINY_TEXT: appColors.color.blue4,
    };
    var bgColor = variant.type === 'LARGE_TEXT'
        ? backgroundColors["LARGE_TEXT_".concat(variant.backgroundColor)]
        : backgroundColors[variant.type];
    return (_jsx(Chip, __assign({ onClick: onClick, label: label, sx: __assign(__assign(__assign({}, getChipStyle(variant)), { cursor: onClick ? 'pointer' : 'default', backgroundColor: bgColor, '& .MuiChip-icon': muiChipIconSx, '& .MuiChip-label': __assign(__assign({}, muiLabelSx), { marginLeft: variant.type === 'SMALL_TEXT' && variant.leftIcon ? 1 : 0 }), opacity: isSelected ? 1 : 0.5 }), sx) }, (variant.type === 'SMALL_TEXT' &&
        variant.leftIcon && {
        icon: (_jsx(Box, { children: _jsx(BackrsIcon, { name: variant.leftIcon.name, alt: variant.leftIcon.alt }) })),
    }))));
};
var largeChipStyle = {
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 'bold',
    color: appColors.neutral.white,
    px: 3,
    pb: 0.25,
    boxSizing: 'border-box',
};
var smallChipStyle = {
    fontSize: 13,
    lineHeight: 1.3,
    fontWeight: 'bold',
    color: appColors.color.navy3,
    px: 2,
    py: 2.25,
    borderRadius: 2,
};
var tinyChipStyle = {
    fontSize: 13,
    lineHeight: 1.3,
    fontWeight: 'bold',
    color: appColors.color.blue1,
    px: 2,
    borderRadius: 100,
};
var muiLabelSx = {
    padding: 0,
    textOverflow: 'ellipsis',
};
var muiChipIconSx = {
    ml: 0,
    mr: 0,
    display: 'flex',
};
